export default __webpack_public_path__ + "static/media/swipingPhone.37951783.png";